import { Injectable } from '@angular/core';
import 'rxjs/add/operator/toPromise';

@Injectable()
export class DialogsService{
    alert: (Title: string, Message: string) => void;    
    success: (Title: string, Message: string) => void;
    confirm:(Title: string, Message: string, cancelButtonText: string, okButtonText: string) => Promise<boolean>;
}


// WEBPACK FOOTER //
// ./src/angular_library/services/dialogs.service.ts